// NG 2
import { Injectable } from '@angular/core';
//import { Route, Router, ActivatedRoute } from '@angular/router';
import { Route, Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { AppConfig } from '../app.config';

@Injectable()
export class BaseService {
    public static config: any;
        router: Router;
        constructor() {                        
        }

        errorHandler(error: Response) {
            if (error.status == 401) {
                                
                sessionStorage.removeItem('loggedInUser');
                window.location.href = '/MIH/#/login?session=0';		
                return Observable.throw({ ExceptionMessage: 'Session is expired, please login again!' });
            }
            else {
                if (error.status == 0) {
                    return Observable.throw({ ExceptionMessage: "Unable to connect to server"});
                }
                else {
                    var error1 = error.json();
                    if (error1.ExceptionMessage == 'SessionNotExists: RetrieveSession') {
                        var messge = error1.ExceptionMessage;      //bug 53567-webAPI Session Timeout-
                        window.location.href = '/MIH/#/login?session=0';
                        return Observable.throw({ ExceptionMessage: 'Session is expired, , please login again!' });

                    }

                    return Observable.throw(error || { ExceptionMessage: ' Internal Server Error' });
                }
                //if (error.statusText == null || error.statusText == '')
                //    error.statusText = 'Server Error';

                //console.log(error.statusText);
                //return Observable.throw(error || { statusText: 'Server Error' });
            }
        }
    
        blobRequestOptions() {
            let headers = new Headers({ 'Content-Type': 'application/json', });
            headers.append('token', 'Bearer ' + sessionStorage.getItem('token'));
            let options = new RequestOptions({ 'headers': headers, responseType: ResponseContentType.Blob });
            return options;
        }

        addHeader() {
            let headers = new Headers({ 'Content-Type': 'application/json', });
            headers.append('token', 'Bearer ' + sessionStorage.getItem('token'));
            let options = new RequestOptions({ 'headers': headers });

            return options;
        }

        getUser() {
            
            var user = sessionStorage.getItem('loggedInUser');
            if (user != null)
                return JSON.parse(user);
            else
                return null;
        }   
}
